import styles from './OverviewCard.module.scss'
import classNames from 'classnames'
import { OverviewCardProps } from './types'
import { Card, Heading } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import LoadingSkeleton from 'components/loading-skeleton/LoadingSkeleton'
import { DATE_FORMAT } from 'constants/constants.ts'

const OverviewCard = ({ date, blocks, isLoading }: OverviewCardProps) => {
  // i18n
  const { t } = useTranslation('billing')

  return (
    <Card as="section" className={styles['overview-card']}>
      <header>
        <Heading as="h2" variant="h5" weight="semi-bold">
          {t(($) => $.billingCycle.overview.lastUpdate)}
        </Heading>
        {isLoading ? <LoadingSkeleton.Rectangle height={22} width={DATE_FORMAT.length + 'ch'} /> : <time dateTime={date}>{date}</time>}
      </header>

      <ul className={styles.blocks}>
        {blocks.map((block, idx) => (
          <li key={idx} className={styles.block}>
            {block.addendum ? (
              <div className="flex-col">
                <strong className={styles.label}>{block.label}</strong>
                {!!block.addendum && <small className={styles.addendum}>{block.addendum}</small>}
              </div>
            ) : (
              <strong className={styles.label}>{block.label}</strong>
            )}

            {isLoading ? (
              <LoadingSkeleton.Rectangle height={24} width={200} />
            ) : (
              <data value={block.rawValue} className={classNames(styles.value, block.valueClass)}>
                {block.formattedValue}
              </data>
            )}
          </li>
        ))}
      </ul>
    </Card>
  )
}

export default OverviewCard
